import { Api } from '../AApi'

export const API_LAYER = new Api(
  {
    url: 'layers',
    isConvertFormData: true,
    only: ['list', 'update', 'destroy'],
  },
  {
    create: {
      async request(id, data) {
        return this.sdk
          .request({
            method: 'post',
            url: `layers/${id}`,
            data,
          })
          .then((res) => res.data)
      },
    },
    getFeatureType: {
      async request(id, data) {
        return this.sdk
          .request({
            method: 'get',
            url: `layers/${id}/feature-type`,
          })
          .then((res) => res.data.data)
      },
      type: 'getDetail',
    },
    export: {
      async request(id) {
        return this.sdk
          .request({
            method: 'get',
            url: `layers-export/${id}`,
            responseType: 'blob',
          })
          .then((res) => res.data)
      },
    },

    publicLayer: {
      async request(id, data) {
        return this.sdk
          .request({
            method: 'put',
            url: `layer-public/${id}`,
            data,
          })
          .then((res) => res.data.data)
      },
    },
    getPublicLayers: {
      async request() {
        return this.sdk
          .request({
            method: 'get',
            url: `layers-public`,
          })
          .then((res) => res.data.data)
      },
    },
    getLayerData: {
      async request(params) {
        return this.sdk
          .request({
            method: 'get',
            url: `layers-info`,
            params,
          })
          .then((res) => res.data.data)
      },
    },
    setInfor: {
      async request(data, id) {
        return this.sdk
          .request({
            method: 'put',
            url: `layer-show-field/${id}`,
            data,
          })
          .then((res) => res.data.data)
      },
    },
    getLayerFields: {
      async request(id) {
        return this.sdk
          .request({
            method: 'get',
            url: `layers/${id}/fields`,
          })
          .then((res) => res.data.data)
      },
    },
  }
)

export const API_LAYER_FIELD = new Api({ url: `layers/{id}/fields` })

export const API_LAYER_FEATURE = new Api({ url: `layers/{id}/features` })
